var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.249 1.646C10.6376 1.58824 11.0334 1.68528 11.3513 1.91625C11.6691 2.14722 11.8837 2.49369 11.9488 2.88116C12.0139 3.26864 11.9243 3.66619 11.6994 3.98835C11.4745 4.31051 11.1322 4.53157 10.746 4.604C8.99914 4.90065 7.41366 5.80603 6.27043 7.15974C5.12721 8.51346 4.50003 10.2281 4.5 12C4.5 13.9891 5.29018 15.8968 6.6967 17.3033C8.10322 18.7098 10.0109 19.5 12 19.5V22.5C6.201 22.5 1.5 17.8 1.5 12C1.5 6.855 5.226 2.49 10.249 1.646Z",
    fill: "url(#paint0_linear_18715_17307)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.892 4.29799C17.0235 4.15124 17.1827 4.03185 17.3604 3.94664C17.5381 3.86143 17.7309 3.81208 17.9277 3.8014C18.1245 3.79072 18.3214 3.81892 18.5073 3.8844C18.6932 3.94987 18.8643 4.05134 19.011 4.18299C20.1102 5.16682 20.9892 6.37173 21.5905 7.71882C22.1917 9.06591 22.5017 10.5248 22.5 12C22.5 17.8 17.799 22.5 12 22.5V19.5C13.5182 19.5 15.0006 19.0393 16.2513 18.1788C17.502 17.3182 18.4621 16.0984 19.0047 14.6805C19.5473 13.2626 19.6469 11.7135 19.2902 10.2378C18.9335 8.76216 18.1373 7.42949 17.007 6.41599C16.7109 6.15036 16.5325 5.778 16.5109 5.38081C16.4893 4.98361 16.6264 4.59412 16.892 4.29799Z",
    fill: "url(#paint1_linear_18715_17307)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18715_17307",
    x1: 526.5,
    y1: 111.637,
    x2: 526.5,
    y2: 1917.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#699BF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#699BF7",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18715_17307",
    x1: 537,
    y1: 288.799,
    x2: 537,
    y2: 1633.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#699BF7",
    stopOpacity: 0.55
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.bd22ca4f4803c74909397f805ef399cf.svg";
export { ForwardRef as ReactComponent };